export class LoadStream {
  static readonly type = '[Stream] Load Stream';

  constructor(readonly eventSlug: string) {}
}
